
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PromptsConfiguration from '@/components/rally-intelligence/PromptsConfiguration.vue';
import PromptsList from '@/components/rally-intelligence/PromptsList.vue';
import SuitesHeader from '@/components/shared/suites/SuitesHeader.vue';
import Tabs from '@/components/shared/Tabs.vue';

@Component<RallyIntelligence>({
	components: {
		PromptsConfiguration,
		PromptsList,
		SuitesHeader,
		Tabs
	}
})
export default class RallyIntelligence extends Vue {
	@Getter('isRallyIntelligenceEnabled', { namespace: 'auth' }) private isRallyIntelligenceEnabled!: boolean;

	private get tabs(): Tab[] {
		return [
			{ key: 'prompts', label: this.$t('rally-intelligence.tabs.prompts') },
			{ key: 'configuration', label: this.$t('rally-intelligence.tabs.configuration') }
		];
	}

	private get initialTab(): string {
		const hash = window.location.hash.replace('#', '');
		const tab = this.tabs.find(tab => tab.key === hash && !tab.hidden);
		return tab ? tab.key : this.tabs[0].key;
	}

	/**
	 * Update the URL hash when the tab changes.
	 *
	 * @param {Tab} tab
	 * @return {void}
	 */
	private handleTabChange(tab: Tab): void {
		if (tab.key !== 'prompts') {
			this.$router.push(`/rally-intelligence#${tab.key}`).catch(() => {});
		}
		else {
			this.$router.push('/rally-intelligence').catch(() => {});
		}
	}
}
